<template>
  <v-container fluid class="project-view">
    <div v-if="userCanSeeCampaigns">
      <v-tabs
        v-model="tab"
        flat class="project-tabs"
      >
        <v-tab v-for="item in items"
        :disabled="item.disabled"
        :key="item.id"
        >
          {{item.text}}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="item in items"
            :key="item.id"            
          >
            <component ref="cardComponents" :is="item.view" :data="project.feedbacks" :id="project.projectId" :status="project.status" :developer="project.developer" :key="item.id + item.key"/>
          </v-tab-item>
      </v-tabs-items>
    </div>
    <project-details v-else />
  
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  components:{
    ProjectDetails:()=>import('./ProjectDetails.vue'),
    FundingCampaignAdmin:()=>import('../fundingModules/FundingCampaignAdmin.vue'),
    FeedbackList:()=>import('../feedbackModule/FeedbackList.vue'),
  },
  data(){
    return {
      items:[
        {
          id:'ProjectDetails',
          text:'Detalles de proyecto',
          view:'ProjectDetails',
          disabled:false,
          key:1
        }        
      ],
      fundingCampaignTab:
      {
        id:'FundingCampaignAdmin',
        text:'Campañas de fondeo',
        view:'FundingCampaignAdmin',
        disabled: false,
          key:1
      },
      projectFeedback:{
        id:'FeedbackList',
        text:'Revisión',
        view:'FeedbackList',
        disabled: false,
          key:1
      },
      tab:undefined,
      project:{
        status: 'Draft'
      }
    }
  },
  beforeMount(){
    this.$cf_api.getProject(this.$route.params.id).then(response=>{
      console.log('resp', response.data)
      this.project = response.data
      this.items.splice(1, 1, this.fundingCampaignTab)
      if(this.project.fundingCampaignDTO===null){
        this.project.fundingCampaignDTO= {creditsAmount:0, creditsFunded:0}
      }
      this.portraitId =  this.project.projectCards.find(pjc=>pjc.cardType===0).imageId
      
      if(this.$store.getters.getUserRole === 'admin' || this.project.feedbacks.length > 0 ){
        this.items.splice(2,0,this.projectFeedback)
        
      }
    })
  },
  computed:{
    ...mapGetters([
      'oidcIsAuthenticated',
    ]),
    userCanSeeCampaigns(){
      return this.oidcIsAuthenticated
    }
  },
  watch:{
    tab:function(newVal, oldVal){
      if(newVal !== oldVal){
        this.items[newVal].key++        
      }
    }
  }
}
</script>
<style scoped>
.project-view{min-height:calc(100vh - 64px);background:#f8f5ef;padding:34px!important;font-family:Inter,Arial,sans-serif}.project-tabs{background:#fff;border-bottom:1px solid #e6e2db}.project-tabs :deep(.v-tab){font-size:11px;font-weight:700;letter-spacing:.5px;color:#60747e}.project-tabs :deep(.v-tab--active){color:#d5654c}
</style>
